import { twMerge } from 'tailwind-merge'
import definePrimitive from '../../util/definePrimitive'

const Root = definePrimitive({
  name: 'PageView',
  element: 'section',
  className: twMerge('typo-body grid px-8 pb-4 [grid-template-areas:"page-header""main"] [grid-template-rows:6rem]')
})

export {
  Root
}
